import plusTealIcon from "@assets/images/plus-teal.svg";
import TrashCan from "@assets/images/trash.svg";
import { Button } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { menuWidth, shrunkMenuWidth } from "@saleor/components/Siderbar";
import useAppState from "@saleor/hooks/useAppState";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";
import SVG from "react-inlinesvg";
import { useIntl } from "react-intl";

interface BottomBarProps {
  selectedLine: number;
  disabled: boolean;
  onClick: () => void;
  onSubmit: () => void;
  onDeleteClick: () => void;
}

interface propsStyleType {
  expandMenu?: boolean;
  bodyPaddingRight?: number;
}

const useStyles = makeStyles<propsStyleType>(
  () => ({
    bottomBar: {
      position: "fixed",
      bottom: 0,
      background: "#FFF",
      borderTopLeftRadius: 20,
      borderTopRightRadius: 20,
      padding: 20,
      height: 90,
      width: props =>
        props.expandMenu
          ? `calc(100% - ${menuWidth}px - 50px - ${props.bodyPaddingRight}px)`
          : `calc(100% - ${shrunkMenuWidth}px - 50px - ${props.bodyPaddingRight}px)`,
      display: "flex",
      alignItems: "center",
      zIndex: 9
    },
    barRight: {
      marginLeft: "auto",
      display: "flex",
      alignItems: "center"
    },
    btnOrder: {
      marginLeft: 48,
      "& button": {
        paddingLeft: 67,
        paddingRight: 67,
        "& .MuiButton-label": {
          fontSize: "1.6rem",
          fontWeight: 700
        }
      }
    },
    btnAddMore: {
      "& .MuiButton-label": {
        fontSize: "1.6rem",
        fontWeight: 700
      }
    },
    btnDelete: {
      marginRight: 16,
      padding: "12px"
    },
    colorIconTrash: {
      "& path": {
        stroke: "#FF2600",
        strokeWidth: "2"
      }
    },
    colorDisableIcon: {
      "& path": {
        stroke: "#CCCCCC",
        strokeWidth: "2"
      }
    }
  }),
  { name: "BottomBar" }
);

const BottomBar: React.FC<BottomBarProps> = ({
  selectedLine,
  disabled,
  onSubmit,
  onClick,
  onDeleteClick
}) => {
  const [appState, _] = useAppState();
  const { expandMenu, bodyPaddingRight } = appState;
  const classes = useStyles({ expandMenu, bodyPaddingRight });
  const intl = useIntl();
  return (
    <div className={classes.bottomBar}>
      <div>
        <Button
          id="deleteItems"
          data-testid="deleteItems"
          variant={"outlined"}
          color={"primary"}
          onClick={onDeleteClick}
          className={classes.btnDelete}
          disabled={disabled}
        >
          <SVG
            src={TrashCan}
            className={
              disabled ? classes.colorDisableIcon : classes.colorIconTrash
            }
          />
          <MyTypography component="span" variant="body2" color="inherit">
            {intl.formatMessage({ defaultMessage: "ลบรายการที่เลือก" })} (
            <b>{selectedLine}</b>)
          </MyTypography>
        </Button>
        <Button
          id="addItem"
          data-testid="addItem"
          variant={"outlined"}
          color={"secondary"}
          onClick={onClick}
          className={classes.btnAddMore}
        >
          <SVG src={plusTealIcon} />
          {intl.formatMessage({ defaultMessage: "เพิ่มรายการสินค้า" })}
        </Button>
      </div>
      <div className={classes.barRight}>
        <MyTypography variant="body2">
          เลือก <b>{selectedLine}</b> รายการ
        </MyTypography>
        <div className={classes.btnOrder}>
          <Button
            id="continueButton"
            data-testid="continueButton"
            variant={"contained"}
            color={"secondary"}
            disabled={disabled}
            onClick={onSubmit}
          >
            {intl.formatMessage({ defaultMessage: "ดำเนินการต่อ" })}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BottomBar;
